// extracted by mini-css-extract-plugin
export default {"markdownWrapper":"TermsAndConditionsForFleetPage_markdownWrapper__Un1e6","p":"TermsAndConditionsForFleetPage_p__i0kMZ"};